<template>
    <div class="logindiv">
	<el-row class="login-el-row" >
		<el-col :span="6" :offset="9">
			<div class="login-system-header">
				{{$t('login_systemHeader')}}
			</div>
			<el-card class="login-el-card">
				<div slot="header" >
					<span>{{$t('login_header')}}</span>
				</div>
				<div>
					<el-form status-icon ref="Loginform" :model="Loginform" :rules="Loginrules" >
						<el-form-item prop="userAccount">
							<el-input v-model="Loginform.userAccount" :placeholder="$t('login_userAccount')" >
								<template slot="prepend">
									<i class="fa fa-user fa-lg"></i>
								</template>
							</el-input>
						</el-form-item>
						<el-form-item prop="pwd">
							<el-input v-model="Loginform.pwd" type="password" :placeholder="$t('login_password')" show-password >
								<template slot="prepend">
									<i class="fa fa-unlock-alt fa-lg"></i>
								</template>
							</el-input>
						</el-form-item>
						<el-form-item prop="code">
							<el-input v-model="Loginform.code" :placeholder="$t('login_code')" class="checkcode-el-input" @keyup.enter.native="submitForm('Loginform')">
								<template slot="prepend">
									<i class="fa fa-shield fa-lg"></i>
								</template>
							</el-input>
							<el-tooltip effect="dark" :content="$t('login_changeImg')" placement="right">
								<img :src="imgsrc" @click="changeImg()" />
							</el-tooltip>
						</el-form-item>
						<el-form-item >
							<el-checkbox v-model="Loginform.rememberpwd" >{{$t('login_rememberpwd')}}</el-checkbox>
						</el-form-item>
						<el-form-item >
							<el-button type="primary" :loading="logonloading" @click="submitForm('Loginform')">{{$t('login_submit')}}</el-button>
							<el-button type="info" @click="resetForm('Loginform')" >{{$t('login_reset')}}</el-button>
						</el-form-item>
                        <el-form-item >
                            <span>{{$t('login_Footer1')}}<span style="color:#4dfafe;">{{$t('login_Footer2')}}</span>{{$t('login_Footer3')}}<span style="color:#4dfafe;">{{$t('login_Footer4')}}</span></span>
						</el-form-item>
					</el-form>
				</div>
			</el-card>
			<div class="login-system-footer" style="color:#eee;">
				© 2020 www.centch.com
			</div>
		</el-col>
	</el-row>
    </div>
</template>
<script>
export default {
  name: 'console_login',
  data() {
    return {
      logonloading: false,
      Loginform: {
        userAccount: '',
        pwd: '',
        code: '',
        rememberpwd: false,
      },
      Loginrules: {
        userAccount: [
          {
            required: true,
            message: this.$t('login_userAccountMsg'),
            trigger: 'blur',
          },
        ],
        pwd: [
          {
            required: true,
            message: this.$t('login_passwordMsg'),
            trigger: 'blur',
          },
        ],
        code: [
          {
            required: true,
            message: this.$t('login_codeMsg'),
            trigger: 'blur',
          },
        ],
      },
      imgsrc: this.$hrraxios.defaults.baseURL + this.$api.base.getcode,
      //imgsrc:this.$mock.Random.image('200x100', '#ffcc33', '#FFF', 'png', '3245')
    }
  },
  methods: {
    submitForm: function(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var Vuethis = this
          this.logonloading = true
          this.$hrraxios
            .post(this.$api.base.login, this.Loginform)
            .then(function(response) {
              Vuethis.logonloading = false
              console.log(response)
              var data = response.data
              if (data.Success == true) {
                Vuethis.StorageUserInfo(data.Data)
                Vuethis.rememberPwd()
                Vuethis.$router.push({ path: '/mapconsole' })
              } else {
                Vuethis.$message.error(data.Prompt)
                Vuethis.changeImg()
              }
            })
            .catch(function(error) {
              Vuethis.logonloading = false
              console.log(error)
            })
        } else {
          return false
        }
      })
    },
    resetForm: function(formName) {
      this.$refs[formName].resetFields()
    },
    changeImg: function() {
      this.imgsrc =
        this.$hrraxios.defaults.baseURL +
        this.$api.base.getcode +
        '?r=' +
        Math.random()
      //this.imgsrc=this.$mock.Random.image('100x36', '#ffcc33', '#FFF', 'png', '3245')
    },
    StorageUserInfo(info) {
      this.$store.commit('setUserId', info.userId)
      this.$store.commit('setUserName', info.userName)
      this.$store.commit('setOrganName', info.organName)
      sessionStorage.setItem('access_token', info.access_token)
    },
    rememberPwd() {
      if (this.Loginform.rememberpwd == true) {
        localStorage.setItem('Hrr_userAccount', this.Loginform.userAccount)
        localStorage.setItem('hrr_pwd', this.Loginform.pwd)
      } else {
        localStorage.removeItem('Hrr_userAccount')
        localStorage.removeItem('hrr_pwd')
      }
    },
  },
  created() {
    this.changeImg()
    if (localStorage.getItem('Hrr_userAccount')) {
      this.Loginform.userAccount = localStorage.getItem('Hrr_userAccount')
      this.Loginform.pwd = localStorage.getItem('hrr_pwd')
      this.Loginform.rememberpwd = true
    }
  },
}
</script>
<style scope>
.logindiv {
  background: url('assets/bg_new2.jpg');
  background-size: cover;
  width: 100%;
  height: 100%;
  min-height: 720px;
}
div.login-system-header {
  width: 900px;
  height: 60px;
  line-height: 60px;
  text-align: left;
  font-size: 30px;
  color: #fff;
}
.login-el-row {
  width: 100%;
  padding-top: 9%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0);
}
.login-el-card.el-card {
  width: 400px;
  background-color: rgba(255, 255, 255, 0);
  border: 0;
}
.login-el-card span {
  color: #fff;
}
.login-el-card .el-card__header {
  border: 0;
}
.login-el-card .el-input-group__prepend {
  background-color: #4a65fb;
}
.login-el-card .el-form-item__content {
  border: 0px;
}
.checkcode-el-input {
  width: 62% !important;
}
.checkcode-el-input .el-input-group__prepend {
  padding-right: 18px;
}
.login-el-card .fa-lg {
  font-size: 18px;
  color: #fff;
}
.login-el-card img {
  margin-left: 20px;
  vertical-align: middle;
  cursor: pointer;
}
.login-system-footer {
  width: 400px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #909399;
}
.logindiv .el-form-item__content {
  line-height: 25px;
  font-size: 12px;
}
</style>
